import classNames from 'classnames';
import PropTypes from 'prop-types';

import { numberWithLessDecimals } from 'hb-react/shared/utils/formatNumber';

import style from './index.module.scss';

const Amounts = ({ campaign, selectedAmount, onSelect }) =>
  campaign.amounts.length > 0 && (
    <div className="inline-block">
      {campaign.amounts.map((amount) => (
        <a
          key={amount}
          className={classNames(style.item, {
            [style['item--selected']]: amount === selectedAmount,
          })}
          onClick={() => onSelect(amount)}
          data-testid={amount === selectedAmount ? 'amount-selected' : null}
        >
          {`${campaign.currency.symbol} ${numberWithLessDecimals(amount)}`}
        </a>
      ))}
    </div>
  );

Amounts.propTypes = {
  campaign: PropTypes.object.isRequired,
  selectedAmount: PropTypes.string,
  onSelect: PropTypes.func,
};

export default Amounts;
